var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationGood({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 0.200195C5.0386 0.200195 0.200195 5.0386 0.200195 11.0002C0.200195 16.9618 5.0386 21.8002 11.0002 21.8002C16.9618 21.8002 21.8002 16.9618 21.8002 11.0002C21.8002 5.0386 16.9618 0.200195 11.0002 0.200195ZM8.84019 16.4002L3.4402 11.0002L4.96299 9.4774L8.84019 13.3438L17.0374 5.1466L18.5602 6.68019L8.84019 16.4002Z",
    fill: "#87BC45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationGood);
export default __webpack_public_path__ + "static/media/notificationGood.18d83e357f0b35246fbdac6950521d83.svg";
export { ForwardRef as ReactComponent };